import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView'
import GallaryView from '../views/GallaryView.vue'
function removeQueryParams(to) {
  if (Object.keys(to.query).length)
    return { path: to.path, query: {}, hash: to.hash }
}

function removeHash(to) {
  if (to.hash) return { path: to.path, query: to.query, hash: '' }
}
const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: [removeQueryParams, removeHash],
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    beforeEnter: [removeQueryParams, removeHash],
    component: AboutView
  },
  {
    path:'/gallary',
    name:'gallary',
    component:GallaryView,
    beforeEnter: [removeQueryParams, removeHash],

  },
    {
    path: "/Login",
    name: "Login",
    beforeEnter: [removeQueryParams, removeHash],
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/tutorial",
    name: "tutorial",
   
    beforeEnter: [removeQueryParams, removeHash],
    component: () => import("../views/tutorials/TutorialView.vue"),
  },
  {
    path: "/tutorial/theoretical",
    name: "Theoretical",
    beforeEnter: [removeQueryParams, removeHash],
    component: () => import("../views/tutorials/TheoreticalView.vue"),
  },
  {
    path: "/tutorial/practical",
    name: "practical",
    beforeEnter: [removeQueryParams, removeHash],
    component: () => import("../views/tutorials/PracticalView.vue"),
  },
 {
    path:"/edit/:id",
    name:'editVideo',
    component: () => import("../views/Admin/EditView.vue"),
  },
  {
    path:"/admin/createNewUser",
    name:'createNewUser',
    beforeEnter: [removeQueryParams, removeHash],
    component: () => import("../views/Admin/SignupView.vue"),
  },
  {
    path:"/admin/SelectAllUsers",
    name:'SelectAllUsers',
    component: () => import("../views/Admin/SelectAllUsers.vue"),
  },
  {
    path:"/admin/createNewVideo",
    name:'/signUp',
    component: () => import("../views/Admin/CreateNewVideo.vue"),
  }, 
  {
    path:"/admin/updateVideo",
    name:'updateVideo',
    component: () => import("../views/Admin/UpdateVideo.vue"),
  },
  {
    path:"/admin",
    name:'admin',
    beforeEnter: [removeQueryParams, removeHash],
    component: () => import("../views/Admin/AdminView.vue"),

  }
]
 
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})


export default router
